import { jsx as _jsx } from "react/jsx-runtime";
import { styled as muiStyled } from "@mui/material";
import Icon from "../icon/Icon";
import { New } from "../icon/IconList";
const CouponTag = muiStyled("span")((param)=>{
    let { theme  } = param;
    return {
        padding: "2px 6px",
        borderRadius: "4px",
        backgroundColor: theme.palette.red[0],
        color: theme.palette.red[400],
        ...theme.typography.bold12
    };
});
const EditableTag = muiStyled("span")((param)=>{
    let { theme  } = param;
    return {
        position: "absolute",
        padding: "2px 6px",
        borderRadius: "4px",
        backgroundColor: theme.palette.mint[300],
        color: "#fff",
        boxShadow: "3px 3px 12px 0px rgba(28, 31, 46, 0.06)",
        ...theme.typography.semibold14
    };
});
const OnlySolvookTag = muiStyled("span")((param)=>{
    let { theme , style  } = param;
    return {
        position: "absolute",
        padding: "1px 7px",
        borderRadius: "4px",
        backgroundColor: theme.palette.blackAndWhite.white,
        border: "1px solid ".concat(theme.palette.indigo[200]),
        color: theme.palette.primary.main,
        boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08), 0px 0px 1px 0px rgba(0, 0, 0, 0.04)",
        ...theme.typography.bold14,
        ...style
    };
});
const UpdateTag = muiStyled("span")((param)=>{
    let { theme  } = param;
    return {
        top: "-10px",
        left: "-8px",
        position: "absolute",
        backgroundImage: "",
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "18px"
    };
});
const UpdateTagWithIcon = ()=>{
    return /*#__PURE__*/ _jsx(UpdateTag, {
        children: /*#__PURE__*/ _jsx(Icon, {
            icon: New
        })
    });
};
export { CouponTag, EditableTag, OnlySolvookTag, UpdateTag, UpdateTagWithIcon };
